var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-build-sub-menu',{attrs:{"title":_vm.title,"menu":_vm.menu,"height":"180px","variant":"#113fa9","redirectToPath":_vm.redirectToPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }